module.exports = __webpack_public_path__ + "static/img/login5.2d252a59.png";